module.exports = __webpack_public_path__ + "img/cy.ad4ffdfc.png";